import { Box, styled, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import {
  EPOCUS_PRIMARY,
  EPOCUS_SYNCED_BG,
  EPOCUS_SYNCED_TEXT,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../_lib/epocus-palette";
import { linkToEpocusAdminProgram } from "../links";

const Callout = styled(Box)({
  backgroundColor: EPOCUS_SYNCED_BG,
  borderRadius: 12,
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

const CalloutTitle = styled(Typography)({
  fontSize: rem(14),
  fontWeight: 700,
  color: EPOCUS_SYNCED_TEXT,
});

const AeTitleValue = styled(Typography)({
  fontSize: rem(20),
  fontWeight: 700,
  fontFamily: "monospace",
  color: EPOCUS_TEXT_PRIMARY,
  letterSpacing: "0.06em",
});

const Caption = styled(Typography)({
  fontSize: rem(12),
  color: EPOCUS_TEXT_SECONDARY,
});

const ProgramLink = styled(Link)({
  fontSize: rem(13),
  fontWeight: 700,
  color: EPOCUS_PRIMARY,
  textDecoration: "none",
  alignSelf: "flex-start",
  display: "inline-flex",
  alignItems: "center",
  minHeight: 44,
  padding: "0 4px",
  marginLeft: -4,
});

export const CreatedProgramCallout: FC<{
  programId: string;
  name: string;
  dimseAeTitle?: string | null;
}> = ({ programId, name, dimseAeTitle }) => (
  <Callout role="status">
    <CalloutTitle>{`${name} created`}</CalloutTitle>
    {dimseAeTitle ? (
      <>
        <AeTitleValue>{dimseAeTitle}</AeTitleValue>
        <Caption>
          Set this as the destination AE title when configuring a POCUS device
          to send studies to this program. Routing is already in place.
        </Caption>
      </>
    ) : (
      <Caption>No AE title was reserved for this program.</Caption>
    )}
    <ProgramLink to={linkToEpocusAdminProgram(programId)}>
      Manage users →
    </ProgramLink>
  </Callout>
);
